import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-csearch',
  templateUrl: './csearch.component.html',
  styleUrls: ['./csearch.component.scss']
})
export class CsearchComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
